module.exports = __webpack_public_path__ + "images/giftTree/anniversary.364ebabdcbf63e598264271d36f3ebe0.png";